import sanitizeHtml from 'sanitize-html';

sanitizeHtml.defaults = {
  ...sanitizeHtml.defaults,
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes, span: ['style'], strong: ['style'],
  },
  allowedClasses: { div: ['debug-container'] },
  allowedSchemes: [...sanitizeHtml.defaults.allowedSchemes, 'data', 'https'],
  allowedSchemesByTag: {
    ...sanitizeHtml.defaults.allowedSchemesByTag,
    p: ['style'],
  },
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'p']),
};

const customSanitizeHtml = (html) => sanitizeHtml(html);
export { customSanitizeHtml };
